interface Props {
  large?: boolean;
  text: string;
  sale?: boolean;
}
const SvgBadge: React.FC<Props> = ({ large, text, sale }) => {
  const discount = text?.startsWith("-") || sale;
  const baseW = large ? 48 : 39;
  const diffLength = text?.length - 4;
  const w = diffLength > 0 ? baseW + diffLength * 5 : baseW;
  const scaleX = w / baseW;
  return (
    <>
      {large ? (
        <svg
          style={{ marginTop: -8 }}
          width={w}
          height="21"
          viewBox={`0 0 ${w} 21`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H46.3419C47.0949 0 47.5777 0.800603 47.2264 1.46655L42.4615 10.5L47.2264 19.5335C47.5777 20.1994 47.0948 21 46.3419 21H0V0Z"
            // fill={discount ? "#ED1414" : "#F9A000"}
            className={discount ? "fill-badge-sale" : "fill-badge-new"}
            style={{
              WebkitTransform: `scaleX(${scaleX})`,
              transform: `scaleX(${scaleX})`,
            }}
          />
          <text
            className={
              discount ? "fill-badge-text-sale" : "fill-badge-text-new"
            }
            fontSize={11}
            fontWeight="700"
            x={6}
            y="11.5"
            alignmentBaseline="middle"
          >
            {text}
          </text>
        </svg>
      ) : (
        <svg
          style={{ marginTop: -8 }}
          width={w}
          height="18"
          viewBox={`0 0 ${w} 18`}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H37.382C38.1253 0 38.6088 0.782313 38.2764 1.44721L34.5 9L38.2764 16.5528C38.6088 17.2177 38.1253 18 37.382 18H0V0Z"
            className={discount ? "fill-badge-sale" : "fill-badge-new"}
            style={{
              WebkitTransform: `scaleX(${scaleX})`,
              transform: `scaleX(${scaleX})`,
            }}
          />
          <text
            className={
              discount ? "fill-badge-text-sale" : "fill-badge-text-new"
            }
            fontSize={11}
            fontWeight="700"
            x={5}
            y="9.5"
            // textAnchor="middle"
            alignmentBaseline="middle"
          >
            {text}
          </text>
        </svg>
      )}
    </>
  );
};

export default SvgBadge;
